import { useWhiteLabelStore, useApplicationStore } from '~/store';
import { useClaimStore } from '~/store/claim';
import { useOrdersStore } from '~/store/orders';

export default defineNuxtRouteMiddleware(async to => {
  const store = useWhiteLabelStore();
  const app = useApplicationStore();

  const orderStore = useOrdersStore();
  const claimStore = useClaimStore();

  const { store: queryStore } = to.query;
  const { currentOrder } = orderStore;
  const { token } = to.params;

  const hostname = window.location.hostname === 'localhost' ? null : window.location.hostname;

  let storeId = queryStore || currentOrder?.order?.storeId;

  // Early return if branding is already set
  if (store.get('brand100')) return app.setReady();

  if (to.path.includes('view') && token && !storeId) {
    // Branding must not depend on a guarded read. This middleware is global, so it runs before the
    // page's guest-session middleware has had a chance to redeem an email link — at this point there
    // is no session, the claim read is refused, and an unhandled rejection here took the whole
    // navigation down. The store id is only a nice-to-have: without it, branding resolves from the
    // hostname, which is already what every non-white-label host does.
    try {
      const claim = await claimStore.findClaimById(token);
      storeId = claim?.storeId;
    } catch {
      storeId = null;
    }
  }

  await store.find(hostname, storeId || null);

  app.setReady();
});
